document.addEventListener('product:added', function(event) {
    $.ajax({
        type: 'GET',
        url: "/cart.js",
        async: false,
        beforeSend: (xhr) => {
          if (xhr && xhr.overrideMimeType) {
            xhr.overrideMimeType('application/json;charset=utf-8');
          }
        },
        dataType: 'json',
        success: (data) => {
            updateCartShippingProgress(data.total_price);
            // console.log(data)
            window.custom.lastCartItem = data.items[0]?.product_id || data.items.product_id;
        }
      });
       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
         bubbles: true
       }));
});
//page load
window.addEventListener('load', function () {
    setTimeout(function() {
        var headID = document.getElementsByTagName("head")[0];         
        var newScript = document.createElement('script');
        newScript.type = 'text/javascript';
        newScript.src = 'https://connect.podium.com/widget.js#ORG_TOKEN=930edbf1-5590-4c0a-848c-5f9f62c0a31a';
        newScript.id = 'podium-widget';
        newScript.setAttribute('data-organization-api-token', '930edbf1-5590-4c0a-848c-5f9f62c0a31a');
        newScript.defer = true;
        headID.appendChild(newScript);
    }, 5000);
});
function createCelebration(){
    setTimeout(function(){
        const myElement = document.getElementById("shipping-message");
        party.confetti(myElement, {
            count: party.variation.range(50, 100),
            size: party.variation.range(0.6, 1.4),
        });
    }, 500);
}
function updateCartShippingProgress(total){
    //get last known cart total from local storage 'lastTotal'
    let lastTotal = localStorage.getItem('lastTotal');
    //if lastTotal is null, set it to 0
    if(lastTotal == null){
        lastTotal = 0;
    }
    //if total is null, set it to 0
    if(total == null){
        total = 0;
    }
    //if total is now over window.freeShippingThreshold then wait 2 seconds and addClass active to .confetti
    if(total > window.freeShippingThreshold && lastTotal < window.freeShippingThreshold){

        var script = document.createElement('script');
        script.onload = function () {
            createCelebration();
        };
        script.src = window.partyJsLib;

        document.head.appendChild(script);
        setTimeout(function(){
            $('#progress-position').animate({
                width: 100 + '%'
            }, 500);
        }, 500);
    }
    else{
        setTimeout(function(){
            let percent = (total / window.freeShippingThreshold) * 100;
            if (percent > 100) {
                percent = 100;
            }
            $('#progress-position').animate({
                width: percent + '%'
            }, 500);
        }, 500);
    }

    localStorage.setItem('lastTotal', total);
}
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
    //.variant-preview-image img
    if(variant.featured_image){
        const productId = variant.featured_image.product_id;
        const imagePreview = document.querySelector('img.variant-preview-image[data-product="' + productId + '"]');
        const imagePreviewWrapper = document.querySelector('a.twelve-product-img[data-product="' + productId + '"]');
        if(imagePreview){
            imagePreview.src = 'https:' + variant.featured_image.src;
            //add variant id to imagePreview
            imagePreviewWrapper.setAttribute('data-variant', variant.id);
            imagePreviewWrapper.classList.remove('inactive');
            imagePreviewWrapper.href = 'https:' + variant.featured_image.src;
            imagePreviewWrapper.setAttribute('data-fancybox', 'gallery')
            $(imagePreviewWrapper).show('slow');
            let varaitnId = variant.id;
            setTimeout(function(){
                $(`a.twelve-product-img[data-variant="${varaitnId}"]`).hide('slow');
            }, 5000,varaitnId);
        }
    }

});

 $(document).on('cart.requestComplete', function(event, cart) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
       bubbles: true
     }));
});
 $('.seemore').click(function(e){
	e.preventDefault();
	var parent = $(this).parents('.collection__filter-checkbox-list');
	if(parent.find('[data-hidden-default]').hasClass('filter-item--hidden')){
		parent.find('[data-hidden-default]').removeClass('filter-item--hidden');
		$(this).text('See Less');
    }
	else{
		parent.find('[data-hidden-default]').addClass('filter-item--hidden');
		$(this).text('See More..');
    }	
})
$(".header__cart-toggle").on("click" , function() {
    $.ajax({
        type: 'GET',
        url: "/cart.js",
        async: false,
        beforeSend: (xhr) => {
          if (xhr && xhr.overrideMimeType) {
            xhr.overrideMimeType('application/json;charset=utf-8');
          }
        },
        dataType: 'json',
        success: (data) => {
            updateCartShippingProgress(data.total_price);
            if(window.theme.cartRecommendations && window.theme.cartRecommendationsLoaded == false){
                // createUpSellSection(data);
            }
        }
      });
});

function createUpSellSection(cart){
    let cartItemElement = document.querySelector('.mini-cart__line-item-list');
    //add text
    cartItemElement.insertAdjacentHTML('beforeend', `<span>Before you go...</span>`);
    if(cart){
        console.log(cart);
        let lineItems = cart.items;
        let lastProduct = lineItems[0].product_id;
        $.ajax({
            type: 'GET',
            url: "/recommendations/products.json?product_id=" + lastProduct+ "&limit=4&intent=related",
            async: false,
            beforeSend: (xhr) => {
              if (xhr && xhr.overrideMimeType) {
                xhr.overrideMimeType('application/json;charset=utf-8');
              }
            },
            dataType: 'json',
            success: (data) => {
                // cartItemElement.append(renderUpsellSection(data.products[0]));
                cartItemElement.insertAdjacentHTML('beforeend', renderUpsellSection(data.products[0]));
                window.theme.cartRecommendationsLoaded = true;
            }
        })
    }
}
function renderUpsellSection(product){
    let html = `
    <div class="mini-cart__line-item">
        <div class="mini-cart__image-wrapper">
            <div class="aspect-ratio aspect-ratio--square">
                <img src="${product.featured_image}" alt="${product.title} Image">
            </div>
        </div>
        <div class="mini-cart__item-wrapper">
            <div class="mini-cart__product-info">
                <a class="mini-cart__product-vendor link" href="/collections/vendors?q=${product.vendor}">
                Arbor Collective
                </a>
                <a href="${product.url}" class="mini-cart__product-title text--strong link">
                    ${product.title}
                </a>
                <div class="mini-cart__price-list">
                    <span class="price price--highlight">
                        ${formatMoney(product.price, window.theme.moneyFormat)}
                    </span>
                    ${product.compare_at_price ? '<span class="price price--compare">' + formatMoney(product.compare_at_price, window.theme.moneyFormat) + '</span>' : ''}
                </div>
            </div>
            <div class="mini-cart__quantity">
                <a class="button button--small button--secondary button--fullwidth">
                Add
                </a>
            </div>
        </div>
    </div>`;
    return html;
}
$(document).mouseup(function (e)
{
    var container = $(".select-box");

    if (container.has(e.target).length === 0)
    {
        container.removeClass("open");
    }
});

$("select .select_custom").on("change" , function() {
  
  var selection = $(this).find("option:selected").text(),
      labelFor = $(this).attr("id"),
      label = $("[for='" + labelFor + "']");
    
  label.find(".label-desc").html(selection);
    
});

function hideHeader(){
    $('#shopify-section-header > section > header > div > div > nav').hide('fast');
    $('#shopify-section-header > section > header > div > div > div.header__search-bar-wrapper').hide('fast');
    $('#shopify-section-header > section > header > div > div > div.header__action-list > div.header__action-item.header__action-item--cart.push-cart-icon > a > div > span').hide('fast');
    $('.header__logo').hide('fast');
    $('#shopify-section-header > section > header > div > div > div.header__action-list').css('position', 'absolute');
    $('#shopify-section-header > section > header > div > div > div.header__action-list').css('top', '-10000px');
    $('#shopify-section-header > section > header > div > div > div.header__action-list > div.header__action-item.header__action-item--cart.push-cart-icon > a > div > div').css('margin', '0');
    $('#shopify-section-header > section > header > div > div > div.header__action-list > div.header__action-item.header__action-item--cart').addClass('push-cart-icon');
    $('header').css('padding-top', '0');
    $('header').css('padding-bottom', '0');
}
function showHeader(){
    $('#shopify-section-header > section > header > div > div > nav').show('fast');
    $('#shopify-section-header > section > header > div > div > div.header__search-bar-wrapper').show('fast');
    $('#shopify-section-header > section > header > div > div > div.header__action-list > div.header__action-item.header__action-item--cart.push-cart-icon > a > div > span').show('fast');
    $('.header__logo').show('fast');
    $('#shopify-section-header > section > header > div > div > div.header__action-list').css('position', '');
    $('#shopify-section-header > section > header > div > div > div.header__action-list').css('top', '');
    $('#shopify-section-header > section > header > div > div > div.header__action-list > div.header__action-item.header__action-item--cart.push-cart-icon > a > div > div').css('margin', '');
    $('#shopify-section-header > section > header > div > div > div.header__action-list > div.header__action-item.header__action-item--cart').removeClass('push-cart-icon');
    $('header').css('padding-top', '');
    $('header').css('padding-bottom', '');
}
$(window).on( 'scroll', function(){
    var scroll = $(window).scrollTop();
    if (scroll > 250) {
        hideHeader();
    }
    if (scroll < 100) {
        showHeader();
    }
});
var observer = new IntersectionObserver(function(entries) {
	if(entries[0].isIntersecting === true)
		console.log('Element is fully visible in screen');
        $(".view-more-button").trigger('click');
}, { threshold: [1] });

if(document.querySelector(".view-more-button")){
    observer.observe(document.querySelector(".view-more-button"));
}
function formatMoney(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
  
    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) { return 0; }
  
      number = (number / 100.0).toFixed(precision);
  
      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }
  
    var match = formatString.match(placeholderRegex);
  
    if (match) {
      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
    }
  
    return formatString.replace(placeholderRegex, value);
  };

function openDialog(product) {
    document.querySelector("dialog[data-product='"+ product +"']").showModal();
}
function closeDialog(product) {
    document.querySelector("dialog[data-product='"+ product +"']").close();
}

function addRecommendedProduct(value){
    event.preventDefault(); // Prevent form to be submitted

    event.stopPropagation(); // First, we switch the status of the button

    document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: value
        },
          dataType: 'json', 
         success: function (data) { 
            document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                    button: null,
                    variant: value,
                    quantity: 1
                }
            }));
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
         } 
    });
    event.preventDefault();
}


// Read More

document.getElementById("readMoreBtn").addEventListener("click", function () {
        const extraText = document.getElementById("extra-text");
        const btn = document.getElementById("readMoreBtn");

        if (extraText.style.display === "none") {
            extraText.style.display = "block";
            btn.textContent = "Read Less";
        } else {
            extraText.style.display = "none";
            btn.textContent = "Read More";
        }
 });

const faqItems = document.querySelectorAll('.faq-item');
      faqItems.forEach(item => {
        const question = item.querySelector('.faq-question');
        question.addEventListener('click', () => {
          item.classList.toggle('active');
    });
});